import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class WorkflowDisplayPdfFrameService {
  private templates$ = new BehaviorSubject({});
  selectedtemplates$ = this.templates$.asObservable();
}
